// Minimum token expiration time before renewal is 10 minutes
export const MIN_TOKEN_EXPIRATION_TIME = 600;
// Interval time for token expiration check
export const RENEW_TOKEN_CHECK_INTERVAL_TIME = 60 * 1000;
// Upload directories
export const UPLOAD_DIR = {
    PRODUCTS: 'products',
    AVATAR: 'avatars',
    FILES: 'form_documents'
};